import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from "./plugins/i18n";
import vuetify from "./plugins/vuetify";
import EsriConfig from "@arcgis/core/config";
import Config from "@/config/config";
import LiDARExportService from "@/services/lidar.export.service";

import "@arcgis/core/assets/esri/themes/light/main.css";
import "@/scss/vuetify.scss";
import "@/scss/app.scss";
import "@/scss/map.scss";
import axios from "axios";

EsriConfig.assetsPath = `${process.env.BASE_URL}assets`;
EsriConfig.request.interceptors.push({
  before: function (params) {
    if (params.url.indexOf("api.hkmapservice.gov.hk") >= 0) {
      if (params.requestOptions.query) {
        params.requestOptions.query.key = Config.mapApiKey;
      } else {
        params.requestOptions.query = {
          key: Config.mapApiKey,
        };
      }
    }
  },
  after: function (response) {
    if (!response.ssl) {
      response.ssl = true;
    }
  },
});

Vue.config.productionTip = false;
Vue.prototype.$lidarService = LiDARExportService;

Vue.prototype.$Configs = await axios
  .get(process.env.BASE_URL + "config.json")
  .then(res => {
    return res.data;
  })
  .catch(err => {
    console.log("fail to load config");
  });
new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
